import { render } from "./GetQuotesPage.vue?vue&type=template&id=5f25ff1f&scoped=true"
import script from "./GetQuotesPage.vue?vue&type=script&lang=js"
export * from "./GetQuotesPage.vue?vue&type=script&lang=js"

import "./GetQuotesPage.vue?vue&type=style&index=0&id=5f25ff1f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f25ff1f"]])

export default __exports__